import OutrightSeasonMapper from './outright-season-mapper';
import SportEventModel from '../sport-event/sport-event-model';
import MarketModel from '../market/market-model';

const OutrightSeasonModel = {
    mapper: OutrightSeasonMapper,

    categoryName: {
        type: String,
    },

    countryCode: {
        fieldName: 'u',
        type: String,
    },

    currentSeasonId: {
        fieldName: 'r',
        type: String,
    },

    events: {
        model: SportEventModel,
        type: Array,
    },

    id: {
        fieldName: 'i',
        type: String,
    },

    order: {
        fieldName: 'o',
        type: Number,
    },

    seasonName: {
        type: String,
    },

    programCode: {
        fieldName: 'p',
        type: String,
    },

    sportTypeRefId: {
        type: String,
    },

    year: {
        fieldName: 'y',
        type: String,
    },

    mbn: {
        type: Number,
    },

    nextBetStopDate: {
        type: Number,
    },

    markets: {
        fieldName: 'm',
        modelContext: {
            eventId: 'currentSeasonId',
        },
        model: MarketModel,
        type: Array,
    },
};

export default OutrightSeasonModel;
